<template>
  <v-select
    :items="projectStatusList"
    item-value="id"
    item-text="name"
    v-model="idValue"
    label="Project Status"
    :rules="[requiredCheck()]"
    outlined
  ></v-select>
</template>

<script>
import { required } from '@/lib/formValidations'
import { projectStatusList } from '@/lib/constants/projectStatuses'

export default {
  props: [
    'id',
    'isRequired'
  ],
  data () {
    return {
      projectStatusList
    }
  },
  computed: {
    idValue: {
      get () {
        return this.id
      },
      set (newValue) {
        this.$emit('change', newValue)
      }
    }
  },
  methods: {
    requiredCheck () {
      return !this.isRequired || required('Project status')
    }
  }
}
</script>
